import { createContext, useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();

  const [token, setToken] = useState(localStorage.getItem("authToken") || "");

  const [admin, setAdmin] = useState(() => {
    const storedAdmin = localStorage.getItem("admin");
    try {
      return storedAdmin ? JSON.parse(storedAdmin) : null;
    } catch (e) {
      console.error("Invalid admin JSON in localStorage", e);
      return null;
    }
  });

  useEffect(() => {
    const storedToken = localStorage.getItem("authToken");
    if (storedToken) {
      setToken(storedToken);
    }

    const storedAdmin = localStorage.getItem("admin");
    if (storedAdmin) {
      try {
        setAdmin(JSON.parse(storedAdmin));
      } catch (e) {
        console.error("Error parsing admin data", e);
      }
    }
  }, []);

  const login = (newToken, newAdmin) => {
    localStorage.setItem("authToken", newToken);
    localStorage.setItem("admin", JSON.stringify(newAdmin));
    setToken(newToken);
    setAdmin(newAdmin);
  };

  const logout = () => {
    localStorage.removeItem("authToken");
    localStorage.removeItem("admin");
    setToken("");
    setAdmin(null);
    navigate("/admin/admin_login");
  };

  const getToken = () => token;

  return (
    <AuthContext.Provider value={{ token, admin, login, logout, getToken }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
